import { useState } from "react";

export default function RosterImportPreview({ summary, onConfirm, onCancel, importing = false }) {
  const [selections, setSelections] = useState(
    summary.disciplines.map((d) => ({ key: d.key, disciplineName: d.defaultName, include: true }))
  );
  const [includeJudges, setIncludeJudges] = useState(true);

  const updateSelection = (key, patch) => {
    setSelections((prev) => prev.map((s) => (s.key === key ? { ...s, ...patch } : s)));
  };

  const canConfirm =
    selections.some((s) => s.include && s.disciplineName.trim()) ||
    (includeJudges && summary.judgeNames.length > 0);

  return (
    <div className="bg-dark-700 border border-dark-500 rounded-xl p-4 mb-3">
      <div className="font-display text-xs font-bold text-gray-500 tracking-widest mb-1">ROSTER IMPORT PREVIEW</div>
      <div className="text-xs text-gray-600 mb-3">
        Found {summary.totalRows} row{summary.totalRows === 1 ? "" : "s"}. Confirm the discipline name for each checkbox column below.
      </div>

      {summary.disciplines.length === 0 && (
        <p className="text-gray-600 text-sm py-2">No discipline checkbox columns found in this file.</p>
      )}

      <div className="flex flex-col gap-2 mb-3">
        {summary.disciplines.map((d) => {
          const sel = selections.find((s) => s.key === d.key);
          return (
            <div key={d.key} className="flex items-center gap-2 p-2.5 bg-dark-800 border border-dark-500 rounded-lg">
              <input type="checkbox" aria-label={`Include ${sel.disciplineName || d.sourceHeader} discipline`} checked={sel.include}
                onChange={(e) => updateSelection(d.key, { include: e.target.checked })}
                className="w-4 h-4 shrink-0" />
              <div className="flex-1 min-w-0">
                <input aria-label={`Discipline name for ${d.sourceHeader}`} value={sel.disciplineName}
                  onChange={(e) => updateSelection(d.key, { disciplineName: e.target.value })}
                  disabled={!sel.include}
                  className="w-full p-2 bg-dark-700 border border-dark-500 rounded-lg text-white text-sm outline-none focus:border-gray-400 disabled:opacity-40" />
                <div className="text-xs text-gray-600 mt-1 truncate">from: {d.sourceHeader}</div>
              </div>
              <div className="text-xs font-bold text-gray-400 shrink-0 font-display">{d.fighterNames.length}</div>
            </div>
          );
        })}
      </div>

      {summary.judgeNames.length > 0 && (
        <label className="flex items-center gap-2 p-2.5 mb-2 bg-dark-800 border border-dark-500 rounded-lg cursor-pointer">
          <input type="checkbox" checked={includeJudges} onChange={(e) => setIncludeJudges(e.target.checked)}
            className="w-4 h-4 shrink-0" />
          <span className="text-xs text-gray-400 flex-1">
            Add {summary.judgeNames.length} judge{summary.judgeNames.length === 1 ? "" : "s"} to the event's judge roster
          </span>
        </label>
      )}
      {summary.skippedRows > 0 && (
        <p className="text-xs text-gray-600 mb-2">
          {summary.skippedRows} row{summary.skippedRows === 1 ? "" : "s"} skipped (missing name).
        </p>
      )}

      <div className="flex gap-2 mt-2">
        <button type="button" onClick={onCancel} disabled={importing}
          className="flex-1 p-2.5 bg-dark-800 border border-dark-500 rounded-lg text-gray-500 text-sm font-bold cursor-pointer disabled:opacity-40">
          Cancel
        </button>
        <button type="button" onClick={() => onConfirm(selections, includeJudges)} disabled={!canConfirm || importing}
          className="flex-1 p-2.5 bg-green-action-light text-white rounded-lg text-sm font-display font-bold tracking-wide disabled:opacity-40 border-none cursor-pointer">
          {importing ? "Importing..." : "Confirm Import"}
        </button>
      </div>
    </div>
  );
}
